import { ArrowDropDown, ArrowDropUp, Sort } from '@mui/icons-material';
import React from 'react';
import { ISortState } from '../interfaces/ISortState';

/**
 * A component that displays the appropriate sort icon based on the column's sort state
 * @param {Object} props - The component props
 * @param {string} props.columnName - The name of the column being sorted
 * @param {ISortState} props.sortState - The current sort state containing field and order
 * @returns {JSX.Element} A Material-UI icon component indicating the sort direction
 */
export function ApplicationGridSortIcon({
  columnName,
  sortState,
}: {
  columnName: string;
  sortState: ISortState;
}): JSX.Element {
  if (sortState.field !== columnName) {
    return <Sort />;
  }

  switch (sortState.order) {
    case 'ASC':
      return <ArrowDropUp />;
    case 'DESC':
      return <ArrowDropDown />;
    default:
      return <Sort />;
  }
}
